module.exports = "./app-dist/templates/selected-filters.component.d2a24cc01c5338500796dd3842203c7f.html";